import src from "IMAGE";
export default { src, width: 292, height: 38, blurWidth: 0, blurHeight: 0};
